export const createForm = (action: string, inputs: { [key: string]: string }) => {
  const form = document.createElement('form');
  form.style.display = 'none';
  form.action = action;
  form.method = 'POST';

  Object.keys(inputs).forEach(key => {
    const input = document.createElement('input');
    input.name = key;
    input.value = inputs[key];
    form.appendChild(input);
  });

  return form;
};
